import * as action_types from "../actionTypes";
const initializeState = {
  login: null,
  phishingScore: null,
  malwareScore: null,
  ransomewareScore: null,
  insiderthreatScore: null,
  socialScore: null,
  denialScore: null,
  storeAttendeeId: null,
  urlloginresponse:null,
  urlloginresponseresult:null,
  adminLogin: null,
  adminLogout:null,
  checkstatus:null,
  checkstatus2:null,
  adminSearchUser:null,
  adminSearchUser2:null,
  topusers:null,
  // Cumulative across all levels (including detour retries) for the final campaign result
  correctAnswers: 0,
  wrongAnswers: 0,
  timeSpentInSeconds: 0
};

const GameReducer = (state = initializeState, action) => {
  switch (action.type) {
    case action_types.LOGIN:
      return { ...state, login: action.payload };
      case action_types.ADMIN_LOGIN:
      return { ...state, adminLogin: action.payload };
      case action_types.CLEAR_ADMIN_LOGIN:
      return { ...state, adminLogin: null };
      case action_types.ADMIN_CHECK_STATUS:
      return { ...state, checkstatus: action.payload };
      case action_types.ADMIN_CHECK_STATUS_SECOND:
        return { ...state, checkstatus2: action.payload };
      case action_types.TOP_USERS_OF_DAY:
        return { ...state, topusers: action.payload };
      case action_types.ADMIN_LOGOUT:
        return { ...state, adminLogout: action.payload };
      case action_types.SEARCH_USER:
      return { ...state, adminSearchUser: action.payload };
      case action_types.SEARCH_USER_PLAYER2:
      return { ...state, adminSearchUser2: action.payload };
    case action_types.ADD_MODULE_ANSWERS:
      // Committed once per module, from that module's own local (per-attempt)
      // tally, so a failed attempt's retry via detour never gets added on
      // top of the attempt that actually completed the module.
      return {
        ...state,
        correctAnswers: state.correctAnswers + action.payload.correct,
        wrongAnswers: state.wrongAnswers + action.payload.wrong,
      };
    case action_types.ADD_GAME_TIME:
      return { ...state, timeSpentInSeconds: state.timeSpentInSeconds + action.payload };
    case action_types.PHISHINGMODULE:
      return { ...state, phishingScore: action.payload };
    case action_types.MALWAREMODULE:
      return { ...state, malwareScore: action.payload };
    case action_types.RANSOMEWAREMODULE:
      return { ...state, ransomewareScore: action.payload };
    case action_types.INSIDERTHREAT:
      return { ...state, insiderthreatScore: action.payload };
    case action_types.SOCIALENGINEERINGMODULE:
      return { ...state, socialScore: action.payload };
    case action_types.DENIALSERVICE:
      return { ...state, denialScore: action.payload };
      case action_types.URL_PARAMS:
        // Note: does NOT reset correctAnswers/wrongAnswers/timeSpentInSeconds.
        // URL_PARAMS can in principle fire more than once in a session (e.g.
        // the player navigates back to the splash/start screen mid-game), so
        // resetting the accumulators here would risk wiping progress already
        // recorded via ADD_MODULE_ANSWERS/ADD_GAME_TIME. The reset instead
        // happens once, explicitly, via RESET_GAME_PROGRESS when the first
        // module actually starts.
        return { ...state, urlloginresponse: action.payload,
          urlloginresponseresult:action.payload.payload
         };
      case action_types.RESET_GAME_PROGRESS:
        return { ...state, correctAnswers: 0, wrongAnswers: 0, timeSpentInSeconds: 0 };
    default:
      return state;
  }
};
export default GameReducer;
